import BaseComponentV2 from '../../../../../../library/js/components/base-component-v2';
import AddressSelectionComponent from './address-selection-component';
import {SubmitOnce} from "../../components/submit-once";
import TimeSelection from '../../components/time-selection';

export default class RideEstimateComponent extends BaseComponentV2 {

  constructor(element) {

    super(element);
    this.setupForm();
  };

  setupForm() {

    this.showMainForm();
    $('[name="timezone"]').val(moment.tz.guess());
    new AddressSelectionComponent($('#originAddressComponent'), 'originAddress', 'originPlaceId', 'Pick-Up Location');
    new AddressSelectionComponent($('#destinationAddressComponent'), 'destinationAddress', 'destinationPlaceId', 'Drop-Off Location');
    new SubmitOnce();

    $('#triptype-button').change(function() {
      $('#returnDateTime').toggleClass('hidden');
    });

    let originTimePicker = $('#scheduledTime').pickatime({
      interval: 15,
      onSet: function(context) {
        originTimeUpdated(context);
      }
    }).pickatime('picker');

    let destinationTimePicker = $('#returnScheduledTime').pickatime({
      interval: 15
    }).pickatime('picker');

    let today = new Date();

    let datePickerFirst = $('#scheduledDate').pickadate({
      format: 'mmm dd, yyyy',
      formatSubmit: 'yyyy-mm-dd',
      hiddenName: true,
      min: today,
      onSet: function(context) {
        dateUpdatedOrigin(context);
      }
    }).pickadate('picker');

    let datePickerSecond = $('#returnScheduledDate').pickadate({
      format: 'mmm dd, yyyy',
      formatSubmit: 'yyyy-mm-dd',
      hiddenName: true,
      min: today,
      onSet: function(context) {
        dateUpdatedDestination(context);
      }
    }).pickadate('picker');

    function dateUpdatedOrigin(context) {
      let date = new Date(context.select);
      let currentDate = new Date();
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setSeconds(0);

      datePickerSecond.set('min', date);
      if (date.toString() == currentDate.toString()) {
        let timeString = new Date().toString().split("2019 ")[1];
        let dateString = date.toString().split(" 00:", 1);
        let dateWithTime = new Date(dateString + " " + timeString);
        dateWithTime.setHours(dateWithTime.getHours() + 1);
        dateWithTime.setMinutes(0);

        originTimePicker.set('min', dateWithTime);
        let timeWithDate = new Date(dateString + " " + originTimePicker.get());
        if (timeWithDate < dateWithTime) {
          originTimePicker.set('select', dateWithTime);
        }
      } else {
        originTimePicker.set('min', currentDate);
      }

      if (new Date(datePickerSecond.get()) < new Date(datePickerFirst.get())) {
        datePickerSecond.set('select', new Date(datePickerFirst.get()));
      } else if (!datePickerSecond.get()) {
        datePickerSecond.set('select', new Date(datePickerFirst.get()));
      }

    }

    function originTimeUpdated(context) {
      destinationTimePicker.set('min', originTimePicker.get());
      if (destinationTimePicker.get() && destinationTimePicker.get() < originTimePicker.get()) {
        destinationTimePicker.set('select', originTimePicker.get());
      }
    }

    function dateUpdatedDestination(context) {
      let date = new Date(context.select);
      let currentDate = new Date();
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setSeconds(0);

      if (date.toString() == currentDate.toString() && originTimePicker.get()) {

        destinationTimePicker.set('min', originTimePicker.get());
      } else {
        destinationTimePicker.set('min', currentDate);
      }
    }





    const getEstimateSubmit = this.element.find('#estimateButton');

    getEstimateSubmit.on('click', (event) => {
      event.preventDefault();

      /**
       * Note: hardcoded element here (these are outside this component).
       */
      const originAddressElement = $('#originAddressComponent [name="originAddress"]');
      const originPlaceIdElement = $('#originAddressComponent [name="originPlaceId"]');
      const destinationAddressElement = $('#destinationAddressComponent [name="destinationAddress"]');
      const destinationPlaceIdElement = $('#destinationAddressComponent [name="destinationPlaceId"]');
      const scheduledDateElement = $('[name="scheduledDate"]');
      const scheduledTimeElement = $('[name="scheduledTime"]');
      const returnScheduledDateElement = $('[name="returnScheduledDate"]');
      const returnScheduledTimeElement = $('[name="returnScheduledTime"]');
      const tripTypeElement = $('[name="triptype"]');
      const weightElement = $('[name="weight"]');
      const waitElement = $('[name="wait"]');
      const timezone = $('[name="timezone"]');

      /**
       * Have to pull data from the entire DOM to create this AJAX request.
       */
      const data = {};

      data.originAddress = originAddressElement.val();
      data.originPlaceId = originPlaceIdElement.val();
      data.destinationAddress = destinationAddressElement.val();
      data.destinationPlaceId = destinationPlaceIdElement.val();
      data.scheduledDate = scheduledDateElement.val();
      data.scheduledTime = scheduledTimeElement.val();
      data.tripType = tripTypeElement.is(':checked') ? 'round' : 'oneway';
      data.timezone = timezone.val();

      if (data.tripType === 'round') {
        data.returnScheduledDate = returnScheduledDateElement.val();
        data.returnScheduledTime = returnScheduledTimeElement.val();
        if (!data.returnScheduledDate || !data.returnScheduledTime) {
          return;
        }
        data.wait = waitElement.is(':checked') ? 'on' : undefined;
      }

      this.showSpinner();

      $.ajax({
        url: Web.createAppURL('estimate'),
        method: 'POST',
        data: data,
        dataType: 'json',
        success: (response) => {
          this.stopSpinner();
          this.showResults(response, data.originAddress, data.destinationAddress);
        },
        error: () => {
          this.stopSpinner();
          console.log("error");
        }
      })
    });
  }

  showError(error) {
    element.find('#error').html(error);
  }

  showResults(results, originAddress, destinationAddress) {
    if (results.exactPrice) {

      const regular = "$" + results.exactPrice[0].price;
      const van = "$" + results.exactPrice[1].price;
      const lfs = "$" + results.exactPrice[2].price;
      const baseURL = Web.getBaseURL();

      this.html = `
        <div class="clearfix">
          <button id="resetButton" type="submit" class="clear-button center clearfix ma0 pa0 text-right f-right">X</button>
          <div class="f-left text-left">
            <h4 class="sh-font">${originAddress}</h4>
            <h4 class="sh-font">${destinationAddress}</h4>
          </div>
        </div>
        <div class="clearfix b-top-dark-gray pt3">
          <h4 class="h-font text-left f-left">Standard</h4>
          <h4 class="h-font text-right f-right">${regular}</h4>
        </div>
        <div class="clearfix">
          <h4 class="h-font text-left f-left">Wheelchair</h4>
          <h4 class="h-font text-right f-right">${van}</h4>
        </div>
        <div class="clearfix" style="display:none">
          <h4 class="h-font text-left f-left">Stretcher</h4>
          <h4 class="h-font text-right f-right">${lfs}</h4>
        </div>
        <div class="clearfix mt4">
          <a href="${baseURL}/request-ride" class="red-button center clearfix ph3 w100">Request A Ride</a>
        </div>
</div>
`;
    } else {

      const regular = "$" + results.lowPrice[0].price + " to $" + results.highPrice[0].price;
      const van = "$" + results.lowPrice[1].price + " to $" + results.highPrice[1].price;
      const lfs = "$" + results.lowPrice[2].price + " to $" + results.highPrice[2].price;

      this.html = `
        <div class="clearfix">
          <button id="resetButton" type="submit" class="clear-button center clearfix ma0 pa0 text-right f-right">X</button>
          <div class="f-left text-left">
            <h4 class="sh-font">${originAddress}</h4>
            <h4 class="sh-font">${destinationAddress}</h4>
          </div>
        </div>
        <div class="clearfix b-top-dark-gray pt3">
          <h4 class="h-font text-left f-left">Standard</h4>
          <h4 class="h-font text-right f-right">${regular}</h4>
        </div>
        <div class="clearfix">
          <h4 class="h-font text-left f-left">Wheelchair</h4>
          <h4 class="h-font text-right f-right">${van}</h4>
        </div>
        <div class="clearfix" style="display:none">
          <h4 class="h-font text-left f-left">Stretcher</h4>
          <h4 class="h-font text-right f-right">${lfs}</h4>
        </div>
        <div class="clearfix mt4">
          <a href="${baseURL}/request-ride" class="red-button center clearfix ph3 w100">Request A Ride</a>
        </div>
</div>
`;
    }

    this.renderHTML();

    $('#resetButton').on('click', (event) => {
      this.setupForm();
    });
  }

  showSpinner() {
    const submitButton = this.element.find('#estimateButton');
    submitButton.attr("disabled", "disabled");
    submitButton.html('<img src="images/loading.gif" style="height: 45px; margin: -15px;">');
  }

  stopSpinner() {
    const submitButton = this.element.find('#estimateButton');
    submitButton.removeAttr("disabled");
    submitButton.html('Get Estimate');
  }

  showMainForm() {
    this.html = `
                <form method="POST" action="estimate" class="square-inputs" autocomplete="off" data-submit-once="#estimateButton">
                    <div class="pt2">
                      <div
                              id="originAddressComponent"
                              data-component="addressSelectionComponent"
                              data-selected-address=""
                              data-selected-place-id=""
                              data-error="">
                      </div><!-- JS component -->
                    </div>

                    <div class="pt0">
                      <div
                              id="destinationAddressComponent"
                              data-component="addressSelectionComponent"
                              data-selected-address=""
                              data-selected-place-id=""
                              data-error="">
                      </div><!-- JS component -->
                    </div>
                    
                    <div class="w48 f-left">
                      <input id="scheduledDate"
                             aria-label="date"
                             placeholder="Date"
                             type="date"
                             name="scheduledDate"
                             data-value=""
                             class="form-control dateComponent m-input date-input w100 mb4 f-left black"
                             style="cursor: pointer"/>
                    </div>
                    
                    <div class="w48 f-right"
                         style="position: relative;">
                      <input id="scheduledTime"
                             name="scheduledTime"
                             placeholder="Time"
                             type="text"
                             class="form-control m-input time-select-container">
                    </div>
                    
                    <div class="clearboth mt2 pb5">
                      <input type="checkbox" name="triptype" id="triptype-button" />
                      <label for="triptype-button" class="sh-font dark-gray pa0 text-left mb2 mt2 f-left">Add a Return Trip</label>
                    </div>
                    <br>
                    <div class="clearboth mt0">
                    <div id="returnDateTime" class="hidden">
                      <div class="w48 f-left">
                        <input id="returnScheduledDate"
                               aria-label="date"
                               type="date"
                               placeholder="Return Date"
                               name="returnScheduledDate"
                               data-value=""
                               class="form-control dateComponent m-input date-input w100 mb4 f-left black"
                               style="cursor: pointer"/>
                      </div>
                      
                      <div class="w48 f-right"
                           style="position: relative;">
                        <input id="returnScheduledTime"
                               placeholder="Return Time"
                               name="returnScheduledTime"
                               type="text"
                               class="form-control m-input time-select-container black">
                      </div>
                      <div class="clearboth">
                        <input type="checkbox" name="wait" id="wait-button" />
                        <label for="wait-button" class="sh-font dark-gray pa0 text-center mb4 mt2 f-left">Please wait <b>on site</b> for my return trip.</label>
                      </div>
                    </div>
                    </div>
                    <input type="hidden" name="timezone" />
                    <button id="estimateButton" type="submit" class="red-button center clearfix w100">Get Estimate</button>
                </form>
`;

    this.renderHTML();
  }

  renderHTML() {

    this.render(this.html);
  }
}
